export enum EntityVisibility {
  PUBLIC = 'public',
  PRIVATE = 'private',
}